import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QueueAnim from 'rc-queue-anim';
import { Row, Col, Button } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '@/utils';
import { useNavigate } from 'react-router-dom';
import Icon from 'antd/es/icon';
import { ArrowRightOutlined } from '@ant-design/icons';

function Content(props) {
  const { dataSource, isMobile, ...restProps } = props;
  const {
    wrapper,
    titleWrapper,
    page,
    OverPack: overPackData,
  } = dataSource;
  const [childWrapper, setChildWrapper] = useState(dataSource.childWrapper);
  const [activeProduction, setActiveProduction] = useState('');
  const { t } = useTranslation();
  useEffect(() => {
    setChildWrapper(dataSource.childWrapper);
    clickItem(0);
  }, [dataSource]);

  const navigate = useNavigate();

  function clickItem(index) {
    const newChildWrapper = [...childWrapper.children];
    newChildWrapper.forEach((item, i) => {
      item.active = i === index;
    });
    setChildWrapper({ ...childWrapper, children: newChildWrapper });
    setActiveProduction({ ...childWrapper.children[index].children.children[2] });
  }

  function clickRouter(path) {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <div {...restProps} {...wrapper}>
      <div {...page}>
        <div {...titleWrapper}>
          <h1 {...titleWrapper.children[0]}>
            {t(titleWrapper.children[0].children)}
          </h1>
          <h2 {...titleWrapper.children[1]}>
            {t(titleWrapper.children[1].children)}
          </h2>
        </div>
        <OverPack {...overPackData}>
          <QueueAnim
            type="bottom"
            key="block"
            leaveReverse
            component="div"
            componentProps={childWrapper}
          >
            <Row key="row">
              <Col md={3} xs={24} key="col-1">
                <Row>
                  {childWrapper.children.map((block, i) => {
                    const { children: item, ...other } = block;
                    return (
                      <Col key={i.toString()} onClick={() => clickItem(i)}
                           className={other.active ? 'content0-block active' : 'content0-block'} md={24} xs={6}>
                        <img
                          src={other.active ? require('@/assets/home/' + item.children[0].active) : require('@/assets/home/' + item.children[0].children)} />
                        <br />
                        {t(item.children[1].children)}
                      </Col>
                    );
                  })}
                </Row>
              </Col>
              {
                !!activeProduction.name && (
                  <Col className="production-content-container" md={20} xs={24} offset={isMobile ? 0 : 1} key="col-2">
                    <div className="production-content">
                      <p className="production-content-title">{t(activeProduction.title)}</p>
                      <div className="production-content-text"
                           dangerouslySetInnerHTML={{ __html: t(activeProduction.children) }} />
                      <Button className="production-content-btn" shape="round" icon={<ArrowRightOutlined />}
                              iconPosition="end" onClick={() => clickRouter(activeProduction.path)}>
                        {t('home.learnMore')}
                      </Button>
                    </div>

                    {!isMobile && (<img src={require('@/assets/home/' + activeProduction.img)} />)}
                  </Col>
                )
              }
            </Row>
          </QueueAnim>
        </OverPack>
      </div>
    </div>
  );
}

export default Content;
